// extracted by mini-css-extract-plugin
export default {"root":"mobile-preview-shell_root__m53+a","host":"mobile-preview-shell_host__QlFjK","stage":"mobile-preview-shell_stage__GhRkn","viewport":"mobile-preview-shell_viewport__+a6R2"};